import gsap from 'gsap';
import Sniffer from 'sniffer';

import { app, webgl } from '@/utils/store';

class Loader {
  constructor() {
    this.circles = document.querySelectorAll('.circle');

    this.loader = {
      el: document.getElementById('a-loader'),
      logo: document.querySelector('.loader-logo'),
    };

    this.dom = {
      logo: document.getElementById('a-logo'),
      main: document.querySelector('.a-main'),
      burger: document.getElementById('a-burger'),
      slider: document.getElementById('a-slider'),
      language: document.getElementById('a-language'),
      grid: document.querySelectorAll('.grid-rulers div'),
    };

    this.c1 = document.querySelectorAll('.c1 .half');
    this.c2 = document.querySelectorAll('.c2 .half');
    this.c3 = document.querySelectorAll('.c3 .half');
  }

  init = () => {
    document.body.classList.add('is-loading');

    gsap.set([this.dom.logo, this.dom.language, this.dom.burger, this.dom.slider, this.dom.main], {
      y: window.innerHeight,
    });

    gsap.set(this.dom.grid, {
      scaleY: 0,
    });

    gsap.to(this.loader.logo, {
      delay: 1.5,
      opacity: 1,
      duration: 1,
    });

    setTimeout(() => {
      this.timer();
    }, 1500);

    setTimeout(() => {
      this.out();
    }, 2750);
  }

  out = () => {
    let offset;

    if (Sniffer.isPhone) {
      offset = window.innerHeight * 0.15;
    } else {
      offset = 0;
    }

    gsap.to(this.dom.grid, {
      scaleY: 1,
      duration: 3,
      clearProps: 'all',
      ease: 'expo.inOut',
    });

    gsap.to([this.dom.logo, this.dom.language, this.dom.burger, this.dom.slider, this.dom.main], {
      y: 0,
      duration: 2,
      clearProps: 'transform',
      ease: 'expo.inOut',
    });

    gsap.to(this.loader.el, {
      duration: 2,
      clearProps: 'all',
      ease: 'expo.inOut',
      y: -window.innerHeight,
      onComplete: this.loaded,
    });

    if (app.contact === true) return;

    gsap.to(webgl.app, {
      duration: 2,
      offsetY: offset,
      ease: 'expo.inOut',
    });
  }

  loaded = () => {
    app.loading = false;
    this.loader.el.style.visibility = 'hidden';
    document.body.classList.remove('is-loading');
  }

  timer = () => {
    let colors;
    colors = ['#e5ad64', '#c94450', '#25b5dd'];
    this.animate(this.c1, colors);
    colors = ['#25b5dd', '#e5ad64', '#c94450'];
    this.animate(this.c2, colors);
    colors = ['#c94450', '#25b5dd', '#e5ad64'];
    this.animate(this.c3, colors);
  }

  animate = (el, colors) => {
    // 1
    gsap.set(el, {
      rotateY: 0,
    });

    gsap.set([el[0], el[1]], {
      background: colors[1],
    });

    gsap.set(el[2], {
      background: colors[0],
    });

    gsap.to(el[1], {
      duration: 0.5, rotateY: 180, ease: 'linear',
    });

    gsap.set(el[1], {
      delay: 0.25, background: colors[0],
    });

    // 2
    gsap.set(el, {
      delay: 0.5, rotateY: 0,
    });

    gsap.set(el[0], {
      delay: 0.5, background: colors[0],
    });

    gsap.set(el[2], {
      delay: 0.5, background: colors[2],
    });

    gsap.to(el[1], {
      delay: 0.5, duration: 0.5, rotateY: 180, ease: 'linear',
    });

    gsap.set(el[1], {
      delay: 0.75, background: colors[2],
    });

    // 3
    gsap.set(el, {
      delay: 1, rotateY: 0,
    });

    gsap.set(el[0], {
      delay: 1, background: colors[2],
    });

    gsap.set(el[2], {
      delay: 1, background: colors[1],
    });

    gsap.to(el[1], {
      delay: 1, duration: 0.5, rotateY: 180, ease: 'linear',
    });

    gsap.set(el[1], {
      delay: 1.25, background: colors[1],
    });
  }
}

export default Loader;
